import { Component, OnInit, Input, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { EventEmitter } from '@angular/core';
import { timeStamp } from 'console';

@Component({
    selector: 'app-tech-rating',
    templateUrl: './tech-rating.component.html',
    styleUrls: ['./tech-rating.component.scss'],
    standalone: false
})
export class TechRatingComponent implements OnInit {
  @Input() title: string;
  @Input() information: string;
  @Input() info: string;
  @Input() positiveButton: string;
  @Input() negativeButton: string;

  @Output() passRating = new EventEmitter<string>();

  ratingPercentage: number = 0.0;
  sr_referenceNo: string = '';
  isNotNum = false;

  // * 0 to 100, Case sensitive at least 2 decimal, no leading 0 and no negative number
  pattern = /^(100|0|([1-9][0-9]?(\.[0-9]{2})?))$/;

  constructor(public activeModal: NgbActiveModal) {}

  ngOnInit() {
    this.sr_referenceNo = this.info;
  }

  checkValid(event) {
    const inputPercentage = <HTMLInputElement>document.getElementById('cbm_rating');
    const val = inputPercentage.value;
    if (isNaN(parseFloat(val)) || isNaN(parseInt(val))) {
      console.log('here!', val);
      this.isNotNum = true;
      const btn = <HTMLButtonElement>document.getElementById('btn_save');
      btn.disabled = true;
    } else {
      if (this.pattern.test(val)) {
        console.log('correct');
        this.isNotNum = false;
        const btn = <HTMLButtonElement>document.getElementById('btn_save');
        btn.disabled = false;
        this.ratingPercentage = parseFloat(inputPercentage.value);
      } else {
        console.log('incorrect');
        this.isNotNum = true;
        const btn = <HTMLButtonElement>document.getElementById('btn_save');
        btn.disabled = true;
      }
    }
  }

  submitRating() {
    const valRating = this.ratingPercentage.toString() + '%';
    console.log('RATING = ', valRating);
    this.passRating.emit(valRating);
    this.activeModal.close();
    /*this.adminService.submitCBMRating(this.sr_referenceNo, valRating).subscribe(resp => {
      console.log("HERE GOSSE = ", resp)
      if(resp['status'] == 200)
      {
        this.activeModal.close();
      }
    })*/
  }
}
